export function createSpellCheck(data) {
    return {
        originalQuery: data.originalQuery,
        correctedQuery: data.correctedQuery.value,
        type: data.type,
    };
}
//# sourceMappingURL=createSpellCheck.js.map